import { FormItem, MenuPresets, TextInput } from '@framework/form';
import { RowElement } from '@framework/ui';
import { yup } from '@framework/validation';
import React from 'react';
import { RichTextAdvancedInput } from '../../../../../inputs/rich-text-advanced/RichTextAdvancedInput';
import { RichTextAdvancedSchema } from '../../../../../inputs/rich-text-advanced/schema/RichTextAdvancedSchema';
import { isExpressionReferenceOfObjectsArray } from '../../../../expressions/datatype/isExpressionReferenceOfObjectsArray';
import { DefaultAssignableExpressionSchema } from '../../../../expressions/repository/assignable/AssignableExpressionSchema';
import { ReferenceSchema } from '../../../../expressions/validation/ReferenceSchema';
import { RulesSchema } from '../../../../rules/repository/RulesSchema';
import { CommonBaseWidgetSchema } from '../../../CommonBaseWidgetSchema';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { uniqueWidgetCodeSchema } from '../../../validation/uniqueWidgetCodeSchema';
import { ConfirmationConfigInput } from '../../advanced/confirm/shared/ConfirmationConfigInput';
import { ConfirmationConfigSchema } from '../../advanced/confirm/shared/ConfirmationConfigSchema';
import { BaseLayoutColSpanInput } from '../../common/BaseLayoutColSpanInput';
import { DefaultValueInput } from '../../common/DefaultValueInput';
import { IInputWidget } from '../IInputWidget';
import { getWidgetProps } from './util/getWidgetProps';

export const CommonInputWidgetConfigSchema: yup.ObjectSchema<IInputWidget> =
  CommonBaseWidgetSchema.shape({
    rules: RulesSchema,
    code: uniqueWidgetCodeSchema,
    label: RichTextAdvancedSchema.nonNullable().label('Etichetta'),
    placeholder: yup.string().optional().label('Placeholder'),
    helpText: RichTextAdvancedSchema.optional()
      .default([])
      .label('Testo di aiuto'),
    defaultValue: DefaultAssignableExpressionSchema.optional(),
    confirmation: ConfirmationConfigSchema,
    defaultValueChildren: yup
      .array(ReferenceSchema.label('Riferimento').nullable())
      .when(['defaultValue'], ([defaultValue], schema) =>
        isExpressionReferenceOfObjectsArray(defaultValue)
          ? schema.required()
          : schema.notRequired().strip(),
      ),
  }).required();

export interface ICommonConfigComponentProps
  extends IWidgetComponentProps<IInputWidget> {
  hideConfigPlaceholder?: boolean;
  hideConfigDefaultValue?: boolean;
  hideConfigHelpText?: boolean;
  hideConfigLabel?: boolean;
  /** Impedisci di impostare il collegamento a un widget di conferma */
  noConfirmation?: boolean;
}

export function CommonConfigComponent(props: ICommonConfigComponentProps) {
  const options = getWidgetProps({ ...props, preview: true });

  return (
    <div>
      <RowElement>
        <FormItem name="code" label="Codice">
          <TextInput name="code" />
        </FormItem>
        <BaseLayoutColSpanInput isTableColumn={options.isTableColumn} />
      </RowElement>
      {!props.hideConfigLabel && (
        <FormItem name="label" label="Etichetta">
          <RichTextAdvancedInput
            name="label"
            rows={2}
            menus={MenuPresets.Minimal}
          />
        </FormItem>
      )}

      {!props.hideConfigPlaceholder && (
        <FormItem name="placeholder" label="Placeholder">
          <TextInput name="placeholder" />
        </FormItem>
      )}
      {!props.hideConfigHelpText && (
        <FormItem name="helpText" label="Testo di aiuto">
          <RichTextAdvancedInput
            name="helpText"
            rows={2}
            menus={MenuPresets.Minimal}
          />
        </FormItem>
      )}

      {!props.hideConfigDefaultValue && (
        <>
          <DefaultValueInput />
          {/* La conferma è impossibile senza un default */}
          {!props.noConfirmation && (
            <ConfirmationConfigInput name="confirmation" />
          )}
        </>
      )}
    </div>
  );
}
